import React, { Fragment } from "react";

const Footer = ()=> {
    return (
        <Fragment>
        <div className="linkedinChild">
            <a href="www.linkedin.com/in/yvonnearmelia" target="_blank">Linkedin</a>
        </div>

        <div className="instagramChild">
            <a href="https://www.instagram.com/yvonnearmelia/" target="_blank">Instagram</a>
        </div>

        <div className="twitterChild">
            <a href="https://github.com/yvonneivon" target="_blank">Github</a>
        </div>
        </Fragment>
    );
};

export default Footer